import { Component, OnInit } from '@angular/core';
import { GlobalService } from './services/global.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  title = 'app';

  constructor(
    public _globalService: GlobalService,
    private _router: Router
  ) {

  }

  ngOnInit() {
    // console.log(`app init`);
  }

}



// WEBPACK FOOTER //
// ./src/app/app.component.ts